import { useState } from "react";
import { useFormik } from 'formik';
import { useHistory } from "react-router-dom";
import * as Yup from 'yup';

import { ModelOfAgency } from 'src/database/index';

import api from 'src/services/api';

export const useFormCreateAgencys = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const history = useHistory();

  const validationSchema = Yup.object().shape({
    NOME: Yup.string().required('* Campo obrigatório'),
    CNPJ: Yup.string().required('* Campo obrigatório'),
    BAIRRO: Yup.string(),
    CEP: Yup.string(),
    CIDADE: Yup.string().required('* Campo obrigatório'),
    ENDERECO: Yup.string(),
  });

  const saveAgency = async (agency: ModelOfAgency) => {
    setLoading(true);

    const newAgency: ModelOfAgency = {
      ...agency,
    }

    api.post('agencys', newAgency)
      .then(() => {
        if (window.location.href === '/agencyForm') history.push('/listAgencys')

        setLoading(false);
      }).catch((err) => {
        alert('Erro no cadastro.');

        console.log(err);
        setLoading(false);
      });
  }

  const formik = useFormik<ModelOfAgency>({
    initialValues: {
      NOME_ORGAO: '',
      CNPJ_ORGAO: '',
      BAIRRO_ORGAO: '',
      CEP_ORGAO: '',
      CIDADE_ORGAO: '',
      ENDERECO_ORGAO: '',
      STATUS: 0
    },
    onSubmit: async values => await saveAgency(values),
    validationSchema
  });

  return {
    getAgencyFormController: {
      formik,
      loading,
    }
  };
};
